<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Security details</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <ng-container *ngFor="let security of securityFormArray?.controls; index as i">
      <mat-card appearance="outlined" [formGroup]="security">
        <mat-card-header>
          <mat-card-title>Security {{i+1}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="row">
            <!-- left side-->
            <div class="col-sm-6">
              <!-- Security Address -->
              <mat-card appearance="outlined" *ngIf="(!security.value.useAsSecurity || (security.value.useAsSecurity && security.value.propertyNotFound)) || (!security.value.useAsSecurity && !security.value.propertyNotFound)">
                <mat-card-content>
                  <div class="row" *ngIf="!security.value.useAsSecurity || (security.value.useAsSecurity && security.value.propertyNotFound)">
                    <div class="col-sm-12" *ngIf="!security.value.useAsSecurity">
                      <mat-checkbox (change)="handleSecurityFound($event.checked, security)" formControlName="propertyNotFound" [disabled]="isFurtherAdvance && faType === 'existing-security'">I haven't found a property yet</mat-checkbox>
                    </div>
                    <div class="col-sm-12" *ngIf="security.value.useAsSecurity && security.value.propertyNotFound">
                      <mat-checkbox [disabled]="true" [checked]="security.value.propertyNotFound">I haven't found a property yet</mat-checkbox>
                    </div>
                  </div>
                  <div class="row" *ngIf="!security.value.useAsSecurity && !security.get('propertyNotFound')?.value">
                    <div class="col-sm-12">
                      <app-address-suggestions
                        [formGroup]="security"
                        [control]="'securityAddress'"
                      ></app-address-suggestions>
                      <fmc-address-search
                        [readonly]="isFurtherAdvance && faType === 'existing-security'"
                        [mode]="'external'"
                        [allowPOBox]="false"
                        [parentFormGroup]="security"
                        [controlName]="'securityAddress'"
                        [placeholderText]="'Search for an address'"
                      ></fmc-address-search>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
              <mat-card appearance="outlined" *ngIf="security.value.useAsSecurity && !security.value.propertyNotFound">
                <mat-card-content>
                  <div class="row">
                    <div class="col-sm-12">
                      <span>{{getSecurityAddress(security)}}</span>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
              <mat-card *ngIf="isSMSF && security.value?.securityType === 'commercial'" appearance="outlined">
                <mat-card-content>
                  <div class="row">
                    <div class="col-sm-12">
                      <div>
                        <strong>Security Use:</strong>
                      </div>
                      <span>
                        If the Property will be leased to a related company or business the Security Use will be Owner Occupied
                      </span>
                      <br>
                      <span>
                        If the Property will be leased to an unrelated company or business the Security Use will be Investment
                      </span>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
              <!-- Security Details -->
              <mat-card appearance="outlined">
                <mat-card-content>
                  <div class="row">
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Mortgage type</mat-label>
                        <mat-select [panelWidth]="null" placeholder="Mortgage type" formControlName="mortgageType">
                          <mat-option *ngFor="let type of mortgageTypes" [value]="type.id">{{type.text}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Security use</mat-label>
                        <mat-select [panelWidth]="null" placeholder="Security use" formControlName="occupancy">
                          <mat-option *ngFor="let type of occupancyTypes" [value]="type.id">{{type.text}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Security type</mat-label>
                        <mat-select [panelWidth]="null" placeholder="Security type" formControlName="securityType">
                          <mat-option *ngFor="let type of filteredSecurityTypes" [value]="type.id">{{type.text}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Security status</mat-label>
                        <mat-select [panelWidth]="null" placeholder="Security status" formControlName="securityStatus">
                          <mat-option *ngFor="let type of securityStatii" [value]="type.id">{{type.text}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4 offset-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Estimate value</mat-label>
                        <input matInput placeholder="Estimated value" matInputCommified formControlName="estimatedValue">
                        <span matPrefix>$&nbsp;</span>
                        <span matSuffix>.00</span>
                        <mat-error>
                          <app-validation-partial [formGroup]="securityFormArray.at(i)" [fieldName]="'estimatedValue'"></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
              <!--Mortgagors Details-->
              <mat-card appearance="outlined" *ngIf="security.get('mortgagors')">
                <mat-card-content>
                  <div class="row">
                    <div class="col-sm-10">
                      <strong>Mortgagor Details</strong>
                      <button mat-icon-button name="addMortgagor" color="'primary'" type="button" (click)="addMortgagor(security.get('mortgagors'))"><mat-icon>add_circle_outline</mat-icon></button>
                    </div>
                  </div>
                  <br>
                  <ng-container *ngFor="let mortgagor of security.get('mortgagors').controls; let j = index;">
                    <div [formGroup]="mortgagor">
                      <mat-form-field appearance="outline">
                        <mat-label>Mortgagor name</mat-label>
                        <input matInput formControlName="mortgagorName" placeholder="Mortgagor name">
                        <button type="button" mat-icon-button matSuffix (click)="removeMortgagor(j, security.get('mortgagors'))"
                                color="warn">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </mat-form-field>
                    </div>
                  </ng-container>
                </mat-card-content>
              </mat-card>
            </div>

            <!-- right side-->
            <div class="col-sm-6">

              <!-- Purchase Details  -->
              <mat-card appearance="outlined">
                <mat-card-content>
                  <div class="row">
                    <div class="col-sm-12">
                      <mat-checkbox formControlName="propertyBeingPurchased">This property is being purchased</mat-checkbox>
                    </div>
                  </div>
                  <div class="row" *ngIf="security.value.propertyBeingPurchased">
                    <div class="col-sm-4">
                      <fmc-date-text
                        [parentFormGroup]="security"
                        [controlName]="'contractDate'"
                        [placeholderText]="'Contract date'"
                      ></fmc-date-text>
                    </div>
                    <div class="col-sm-4">
                      <fmc-date-text
                        [parentFormGroup]="security"
                        [controlName]="'financeDate'"
                        [placeholderText]="'Finance date'"
                      ></fmc-date-text>
                    </div>
                    <div class="col-sm-4">
                      <fmc-date-text
                        [parentFormGroup]="security"
                        [controlName]="'settlementDate'"
                        [placeholderText]="'Settlement date'"
                      ></fmc-date-text>
                    </div>
                  </div>
                  <div class="row" *ngIf="security.value.propertyBeingPurchased">
                    <div class=col-sm-12>
                      <fmc-crumb-search
                        [parentFormGroup]="security"
                        [controlName]="'realEstateAgent'"
                        [placeholderText]="'Real estate agent'"
                        [partyRoleType]="'real-estate-agent'"
                      ></fmc-crumb-search>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>

              <!-- Valuation  -->
              <mat-card appearance="outlined" *ngIf="!security.get('propertyNotFound')?.value">
                <mat-card-content>
                  <div class="row">
                    <div class="col-12">
                      If an upfront valuation has been completed with Firstmac select 'Upfront Valuation'
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <mat-form-field appearance="outline">
                        <mat-label>Valuation type</mat-label>
                        <mat-select [panelWidth]="null" placeholder="Valuation type" formControlName="valuationType" (selectionChange)="updateValuation($event.value, i)">
                          <mat-option *ngFor="let type of valuationTypes" [value]="type.id">{{type.text}}</mat-option>
                        </mat-select>
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'valuationType'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <!-- 1strow: subsidiary-valuation -->
                    <div class="col-sm-4" *ngIf="security.value.valuationType === 'subsidiary-valuation'">

                      <mat-form-field appearance="outline">
                        <mat-label>External valuation ID</mat-label>
                        <input matInput placeholder="External valuation ID" formControlName="valexId">
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'valexId'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <!-- 1st row: val-in-hand -->
                    <div class="col-sm-4" *ngIf="security.value.valuationType === 'val-in-hand'">
                      <mat-form-field appearance="outline">
                        <mat-label>Valex ID</mat-label>
                        <input matInput placeholder="Valex ID" formControlName="valexId">
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'valexId'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4" *ngIf="security.value.valuationType === 'val-in-hand'">
                      <fmc-date-text
                        [parentFormGroup]="security"
                        [controlName]="'inspectionDate'"
                        [placeholderText]="'Inspection date'"
                      ></fmc-date-text>
                    </div>
                  </div>
                  <!-- 2nd row: New valuation -->
                  <div class="row" *ngIf="security.value.valuationType === 'new-valuation'">
                    <div class="col-sm-12 d-flex flex-row align-items-center" *ngIf="canSelectValuer">
                      <mat-form-field appearance="outline">
                        <mat-label>Select a valuer</mat-label>
                        <mat-select [panelWidth]="null" placeholder="Select Valuer" (selectionChange)="setValuerName(i, $event.value)"  formControlName="valuerId">
                          <mat-option *ngFor="let valuer of security.value.valuers" [value]="valuer.id">{{valuer.name}}</mat-option>
                        </mat-select>
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'valuerId'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                      <mat-spinner matSuffix [diameter]="20" [strokeWidth]="3" *ngIf="security.value.valuerLoading"></mat-spinner>
                    </div>
                  </div>
                  <div class="row" *ngIf="security.value.valuationType === 'val-in-hand'">
                    <div class="col-sm-12">
                      <mat-form-field appearance="outline">
                        <mat-label>Valuation firm</mat-label>
                        <input matInput placeholder="Valuation firm" formControlName="valuationFirm">
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'valuationFirm'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- 2nd row: Val in hand -->
                  <div class="row" *ngIf="security.value.valuationType === 'val-in-hand'">
                    <div class="col-sm-8">
                      <mat-form-field appearance="outline">
                        <mat-label>Valuer name</mat-label>
                        <input matInput placeholder="Valuer name" formControlName="valuerName">
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="formGroup"
                            [fieldName]="'valuerName'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Qualifications</mat-label>
                        <input matInput placeholder="Qualifications" formControlName="valuerQualifications">
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="formGroup"
                            [fieldName]="'valuerQualifications'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Succeeding rows: Val in hand -->
                  <div class="row" *ngIf="security.value.valuationType === 'val-in-hand'">
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Current use</mat-label>
                        <mat-select [panelWidth]="null" placeholder="Current use" formControlName="currentUse">
                          <mat-option *ngFor="let cuType of currentUseTypes" [value]="cuType.id">{{cuType.text}}</mat-option>
                        </mat-select>
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'currentUse'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Main building</mat-label>
                        <mat-select [panelWidth]="null" placeholder="Main building" formControlName="mainBuilding">
                          <mat-option *ngFor="let bType of buildingTypes" [value]="bType.id">{{bType.text}}</mat-option>
                        </mat-select>
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'mainBuilding'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Zoning</mat-label>
                        <mat-select [panelWidth]="null" placeholder="Zoning" formControlName="zoning">
                          <mat-option *ngFor="let zType of zoningTypes" [value]="zType.id">{{zType.text}}</mat-option>
                        </mat-select>
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'zoning'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row" *ngIf="security.value.valuationType === 'val-in-hand'">
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Interest valued</mat-label>
                        <mat-select [panelWidth]="null" placeholder="Interest valued" formControlName="interestValued">
                          <mat-option *ngFor="let interest of interestValueTypes" [value]="interest.id">{{interest.text}}</mat-option>
                        </mat-select>
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'interestValued'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Living area</mat-label>
                        <input matInput type="number" placeholder="Living area" formControlName="livingArea">
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'livingArea'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Living area measurement</mat-label>
                        <mat-select [panelWidth]="null" placeholder="Living area measurement" formControlName="livingAreaMeasurement">
                          <mat-option *ngFor="let area of areaTypes" [value]="area.id">{{area.text}}</mat-option>
                        </mat-select>
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'livingAreaMeasurement'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row" *ngIf="security.value.valuationType === 'val-in-hand'">
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Units in development</mat-label>
                        <input matInput type="number" placeholder="Units in development" formControlName="unitsInDev">
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'unitsInDev'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Site area</mat-label>
                        <input matInput type="number" placeholder="Site area" formControlName="siteArea">
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'siteArea'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Site area measurement</mat-label>
                        <mat-select [panelWidth]="null" placeholder="Site area measurement" formControlName="siteAreaMeasurement">
                          <mat-option *ngFor="let area of areaTypes" [value]="area.id">{{area.text}}</mat-option>
                        </mat-select>
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'siteSqm'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row" *ngIf="security.value.valuationType === 'val-in-hand'">
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Value component</mat-label>
                        <input matInput placeholder="Value component" formControlName="valueComponent">
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'valueComponent'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Rental value</mat-label>
                        <input matInput type="number" placeholder="Rental value" formControlName="rentalValue">
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'rentalValue'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Insurance value</mat-label>
                        <input matInput type="number" placeholder="Insurance value" formControlName="insuranceValue">
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'insuranceValue'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row" *ngIf="security.value.valuationType === 'val-in-hand'">
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Land value</mat-label>
                        <input matInput type="number" placeholder="Land value" formControlName="landValue">
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'landValue'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Improvements values</mat-label>
                        <input matInput type="number" placeholder="Improvements value" formControlName="improvementsValue">
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'improvementsValue'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Market value</mat-label>
                        <input matInput type="number" placeholder="Market value" formControlName="marketValue">
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="security"
                            [fieldName]="'marketValue'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row" *ngIf="security.value.valuationType === 'val-in-hand'">
                    <div class="col-sm-12">
                      <fmc-crumb-search
                        [parentFormGroup]="security"
                        [controlName]="'builder'"
                        [placeholderText]="'Builder'"
                        [partyRoleType]="'builder'"
                      ></fmc-crumb-search>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>

              <mat-card appearance="outlined" *ngIf="security.value.valuationType === 'new-valuation' && !security.value.propertyNotFound">
                <mat-card-content>
                  <div class="row">
                    <div class="col-12 mb-4">
                      Property Access Information for Valuer
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <mat-form-field appearance="outline">
                        <mat-label>Additional instructions to valuer</mat-label>
                        <textarea rows="5" matInput placeholder="Additional instructions to valuer" formControlName="valuerAccessInstructions"></textarea>
                        <mat-error>
                          <span *ngIf="security.get('valuerAccessInstructions').hasError('maxlength')">Please enter less than 200 characters</span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <mat-checkbox formControlName="valuerAccessBorrower" (change)="checkValuerContact(security, 'valuerAccessBorrower', $event.checked)">Contact Borrower</mat-checkbox>
                      <mat-error *ngIf="(security.get('valuerAccessBorrower').touched || security.get('valuerAccessOther').touched) && security.get('valuerAccessBorrower').hasError('required')">Please select either Contact Borrower or Other contact</mat-error>
                    </div>
                  </div>
                  <div class="row">
                    <div class="offset-1 col-11">
                      <ng-container *ngFor="let borrower of security.get('valuerAccessBorrowers').controls;">
                        <div [formGroup]="borrower">
                          <mat-checkbox formControlName="selected" (change)="checkAccessBorrowerValidation(security, $event.checked)" [disabled]="!security.get('valuerAccessBorrower').value">{{borrower?.value?.firstName}} {{borrower?.value?.lastName}}</mat-checkbox><br>
                        </div>
                      </ng-container>
                      <mat-error *ngIf="valuerAccessBorrowersIsInvalid">
                        Please select one of the applicants
                      </mat-error>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <mat-checkbox formControlName="valuerAccessOther" (change)="checkValuerContact(security, 'valuerAccessOther', $event.checked)">Other Contact for Property Access</mat-checkbox>
                      <mat-error *ngIf="(security.get('valuerAccessBorrower').touched || security.get('valuerAccessOther').touched) && security.get('valuerAccessOther').hasError('required')">Please select either Contact Borrower or Other contact</mat-error>
                    </div>
                  </div>
                  <div class="row">
                    <div class="offset-1 col-11">
                      <mat-form-field appearance="outline">
                        <mat-label>Contact type</mat-label>
                        <mat-select [panelWidth]="null" formControlName="valuerAccessOtherContactType" placeholder="Contact Type" [disabled]="!security.get('valuerAccessOther').value" (selectionChange)="checkPartyType(security, $event.value)">
                          <mat-option *ngFor="let contactType of valuerContactTypes" [value]="contactType.id">{{contactType.text}}</mat-option>
                        </mat-select>
                        <mat-error>
                          <app-validation-partial [formGroup]="security" [fieldName]="'valuerAccessOtherContactType'"></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="offset-1 col-11">
                      <mat-form-field appearance="outline">
                        <mat-label>Property access contact name</mat-label>
                        <input matInput formControlName="valuerAccessOtherContactName" placeholder="Property Access Contact Name" [disabled]="!security.get('valuerAccessOther').value">
                        <mat-error>
                          <span *ngIf="security.get('valuerAccessOtherContactName').hasError('pattern')">Please ensure there is a first and last name</span>
                          <span *ngIf="security.get('valuerAccessOtherContactName').hasError('required')">This field is required</span>
                          <span *ngIf="security.get('valuerAccessOtherContactName').hasError('whitespace')">This field has white space</span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="offset-1 col-11">
                      <mat-form-field appearance="outline">
                        <mat-label>Property access company name</mat-label>
                        <input matInput formControlName="valuerAccessOtherCompanyName" placeholder="Property Access Company Name" [disabled]="!security.get('valuerAccessOther').value">
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="offset-1 col-5">
                      <mat-form-field appearance="outline">
                        <mat-label>Phone type</mat-label>
                        <mat-select [panelWidth]="null" formControlName="valuerAccessOtherPhoneOneType" placeholder="Phone Type" [disabled]="!security.get('valuerAccessOther').value">
                          <mat-option *ngFor="let type of phoneTypes" [value]="type.id">
                            {{type.text}}
                          </mat-option>
                        </mat-select>
                        <mat-error>
                          <span *ngIf="security.get('valuerAccessOtherPhoneOneType').hasError('required')">Please select phone type</span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-6">
                      <fmc-sensis-mobile
                        [parentFormGroup]="security"
                        [controlName]="'valuerAccessOtherPhoneOneNumber'"
                        [acceptedPhoneTypes]="acceptedPhoneTypes[security.value.valuerAccessOtherPhoneOneType] || []"
                        [rejectedPhoneTypes]="rejectedPhoneTypes[security.value.valuerAccessOtherPhoneOneType] || []"
                        [placeholderText]="'Property Access Phone Number 1'"
                      ></fmc-sensis-mobile>
                    </div>
                  </div>
                  <div class="row">
                    <div class="offset-1 col-5">
                      <mat-form-field appearance="outline">
                        <mat-label>Phone type</mat-label>
                        <mat-select [panelWidth]="null" formControlName="valuerAccessOtherPhoneTwoType" placeholder="Phone Type" [disabled]="!security.get('valuerAccessOther').value">
                          <ng-container *ngFor="let type of phoneTypes">
                            <mat-option [value]="type.id" *ngIf="type.ext.Active">{{type.text}}</mat-option>
                          </ng-container>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-6">
                      <fmc-sensis-mobile
                        [parentFormGroup]="security"
                        [controlName]="'valuerAccessOtherPhoneTwoNumber'"
                        [acceptedPhoneTypes]="acceptedPhoneTypes[security.value.valuerAccessOtherPhoneTwoType] || []"
                        [rejectedPhoneTypes]="rejectedPhoneTypes[security.value.valuerAccessOtherPhoneTwoType] || []"
                        [placeholderText]="'Property Access Phone Number 2'"
                      ></fmc-sensis-mobile>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </mat-card-content>


        <mat-card-actions [matTooltip]="security.value.useAsSecurity ? 'This security has been added as the \'Use as Security\' box is ticked in the \'Rental Investment Incomes\'. To remove this Security, go back to \'Rental Investment Incomes\' in the Income Details screen and untick \'Use as Security\'.' : null">
          <button mat-raised-button [disabled]="security.value.collateralId || (isFurtherAdvance && faType === 'existing-security') || security.value.useAsSecurity" class="button-absolute-right mt-3" color="warn" type="button" (click)="removeSecurity(i)">Remove from application</button>
        </mat-card-actions>
      </mat-card>

      <div class="row">
        <div class="col-sm-4 offset-sm-8">
          <button mat-raised-button class="button-absolute-right mt-2" color="primary" type="button" (click)="addSecurity(null, true)" [disabled]="(applicationType === 'new-bridging' && securityFormArray.controls.length > 1) || (isFurtherAdvance && faType === 'existing-security')" *ngIf="i === securityFormArray.controls.length - 1">
            Add another
          </button>
        </div>
      </div>
    </ng-container>

    <div class="row">
      <div class="col-12 text-end">
        <app-further-advance-confirmation
          *ngIf="isFurtherAdvance"
          [formGroup]="formGroup"
          [widgetName]="'app-security-details'"
        ></app-further-advance-confirmation>
      </div>
    </div>
  </mat-card-content>
</mat-card>
